import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ArmComponent} from './arm.component';
import {AcNavModule, InfraModule} from 'ac-infra';
import {RouterModule} from '@angular/router';
import {FlexModule} from '@angular/flex-layout';
import {MaterialModule} from '../material.module';
import {UserMenuModule} from '../components/user-menu/user-menu.module';
import {HeaderToolbarModule} from '../components/header-toolbar/header-toolbar.module';

@NgModule({
  declarations: [
    ArmComponent
  ],
  imports: [
    CommonModule,
    AcNavModule,
    InfraModule,
    RouterModule,
    FlexModule,
    MaterialModule,
    UserMenuModule,
    HeaderToolbarModule
  ],
  exports: [
    ArmComponent
  ]
})
export class ArmModule { }
